import { defineNuxtPlugin } from 'nuxt/app'
import { useToast } from 'vue-toast-notification'
import type {
  ActiveToast,
  ToastPluginApi,
  ToastPropsWithMessage,
} from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-bootstrap.css'

// vue-toast-notification выводит message через innerHTML (dist/index.js:
// `innerHTML: _ctx.message`), то есть каждый тост — HTML-синк. В тосты уходят
// адрес игрока, тексты ошибок с бекенда и от Stripe: сегодня источники
// доверенные, но их полсотни, и следить за каждым call site нереально.
// Экранируем один раз здесь, на обёртке. HTML в тостах приложение не
// использует, так что терять нечего.
function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export default defineNuxtPlugin(() => {
  const toast = useToast({ position: 'top-right' })

  const safeToast: ToastPluginApi = {
    open: (arg: string | ToastPropsWithMessage): ActiveToast =>
      typeof arg === 'string'
        ? toast.open(escapeHtml(arg))
        : toast.open({ ...arg, message: escapeHtml(arg.message) }),
    success: (message, options) => toast.success(escapeHtml(message), options),
    error: (message, options) => toast.error(escapeHtml(message), options),
    info: (message, options) => toast.info(escapeHtml(message), options),
    warning: (message, options) => toast.warning(escapeHtml(message), options),
    default: (message, options) => toast.default(escapeHtml(message), options),
    clear: () => {
      toast.clear()
    },
  }

  return { provide: { toast: safeToast } }
})
